import {
  FAMILLE_SEARCH_SUCCES,
  FAMILLE_SEARCH_ECHEC,
  FAMILLE_SEARCH_RESET,
  FAMILLE_SEARCH_REQUETTE,
  FAMILLE_LISTE_REQUETTE,
  FAMILLE_LISTE_SUCCES,
  FAMILLE_LISTE_ECHEC,
  FAMILLE_SEARCH_REQUETTE_LOC,
  FAMILLE_SEARCH_SUCCES_LOC,
  FAMILLE_SEARCH_ECHEC_LOC,
} from "../constantes/famillesConstantes";
export const familleSearchReducer = (
  state = { familles: [], loading: false },
  action
) => {
  switch (action.type) {
    case FAMILLE_SEARCH_REQUETTE:
      return { loading: true };
    case FAMILLE_SEARCH_SUCCES:
      return { familles: action.payload, loading: false };
    case FAMILLE_SEARCH_ECHEC:
      return { erreur: action.payload, loading: false };
    case FAMILLE_SEARCH_REQUETTE_LOC:
      return { loading: true };
    case FAMILLE_SEARCH_SUCCES_LOC:
      return { familles: action.payload, loading: false };
    case FAMILLE_SEARCH_ECHEC_LOC:
      return { erreur: action.payload, loading: false };
    case FAMILLE_SEARCH_RESET:
      return { familles: [], loading: false };
    default:
      return state;
  }
};
export const familleListeReducer = (state = { familles: [] }, action) => {
  switch (action.type) {
    case FAMILLE_LISTE_REQUETTE:
      return { loading: true, familles: [] };
    case FAMILLE_LISTE_SUCCES:
      return { loading: false, familles: action.payload };
    case FAMILLE_LISTE_ECHEC:
      return { loading: false, erreur: action.payload };

    default:
      return state;
  }
};
